/*package-managers*/
/*platforms*/
/*nodejs*/
/*version-control*/
/*lts-policy*/
/*release-phases*/
/*stable*/
/*beta*/
/*experimental*/
/*deprecated*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "支持策略",
  "description": "了解 Turborepo 的支持政策。"
};
export let structuredData = {
  "contents": [{
    "heading": "软件包管理器-package-managers",
    "content": "¥Package managers"
  }, {
    "heading": "软件包管理器-package-managers",
    "content": "核心 turbo 功能依赖于 JavaScript 生态系统中的包管理器及其对工作区和锁文件格式的实现。"
  }, {
    "heading": "软件包管理器-package-managers",
    "content": "¥Core turbo functionality depends on the package managers in the JavaScript ecosystem and their implementations of Workspaces and\nlockfile formats."
  }, {
    "heading": "软件包管理器-package-managers",
    "content": "包管理器"
  }, {
    "heading": "软件包管理器-package-managers",
    "content": "支持"
  }, {
    "heading": "软件包管理器-package-managers",
    "content": "pnpm 8+"
  }, {
    "heading": "软件包管理器-package-managers",
    "content": "稳定版"
  }, {
    "heading": "软件包管理器-package-managers",
    "content": "npm 8+"
  }, {
    "heading": "软件包管理器-package-managers",
    "content": "稳定版"
  }, {
    "heading": "软件包管理器-package-managers",
    "content": "yarn 1+"
  }, {
    "heading": "软件包管理器-package-managers",
    "content": "稳定版（包含 Yarn Plug'n'Play）"
  }, {
    "heading": "软件包管理器-package-managers",
    "content": "bun 1.2+"
  }, {
    "heading": "软件包管理器-package-managers",
    "content": "稳定版"
  }, {
    "heading": "软件包管理器-package-managers",
    "content": "软件包管理器有自己的发布计划、错误和功能。虽然我们打算跟上新的主要版本，但我们可能无法立即发布支持。"
  }, {
    "heading": "软件包管理器-package-managers",
    "content": "¥Package managers have their own release schedules, bugs, and features. While\nwe intend to keep up with new major versions, we likely will not be able to\nrelease support immediately."
  }, {
    "heading": "平台-platforms",
    "content": "¥Platforms"
  }, {
    "heading": "平台-platforms",
    "content": "turbo 通常支持基于 Debian 的 Linux 发行版、macOS 和 Windows 的 x86_64 和 ARM 64 架构。具体来说，我们通过 npm 构建并交付以下二进制文件："
  }, {
    "heading": "平台-platforms",
    "content": "¥turbo is generally supported on Debian-based Linux distributions, macOS, and\nWindows on both x86_64 and ARM 64 architectures. Specifically, we build and ship\nthe following binaries via npm:"
  }, {
    "heading": "平台-platforms",
    "content": "turbo-darwin-64(搭载 Intel 的 macOS 芯片)"
  }, {
    "heading": "平台-platforms",
    "content": "¥turbo-darwin-64 (macOS with Intel chips)"
  }, {
    "heading": "平台-platforms",
    "content": "turbo-darwin-arm64(搭载 Apple Silicon 的 macOS)"
  }, {
    "heading": "平台-platforms",
    "content": "¥turbo-darwin-arm64 (macOS with Apple Silicon)"
  }, {
    "heading": "平台-platforms",
    "content": "turbo-linux-64"
  }, {
    "heading": "平台-platforms",
    "content": "turbo-linux-arm64"
  }, {
    "heading": "平台-platforms",
    "content": "turbo-windows-64*"
  }, {
    "heading": "平台-platforms",
    "content": "turbo-windows-arm64*"
  }, {
    "heading": "平台-platforms",
    "content": "*: 需要 Windows C 运行时库"
  }, {
    "heading": "平台-platforms",
    "content": "¥*: Requires Windows C Runtime\nLibraries"
  }, {
    "heading": "nodejs-nodejs",
    "content": "核心 turbo 功能不依赖于系统上活动的 Node.js 版本，但 Turborepo 生态系统中的一些包（例如 create-turbo、turbo-ignore 和 eslint-config-turbo）依赖于此。对于这些功能，我们打算支持 Node.js 的活跃和维护 LTS 版本。"
  }, {
    "heading": "nodejs-nodejs",
    "content": "¥Core turbo functionality does not depend on the\nactive Node.js version on your system, but some packages in the Turborepo ecosystem\nsuch as create-turbo, turbo-ignore, and eslint-config-turbo do. For these features,\nwe intend to support the Active and Maintenance LTS versions of Node.js."
  }, {
    "heading": "nodejs-nodejs",
    "content": "Turborepo 的 examples 预计也适用于这些 Node.js 版本。"
  }, {
    "heading": "nodejs-nodejs",
    "content": "¥Turborepo's examples are also expected to work with these Node.js versions."
  }, {
    "heading": "版本控制-version-control",
    "content": "¥Version control"
  }, {
    "heading": "版本控制-version-control",
    "content": "我们支持使用 Git 进行版本控制的仓库，也支持完全没有版本控制的仓库。任何其他版本控制系统都将被忽略。"
  }, {
    "heading": "版本控制-version-control",
    "content": "¥We support repositories that are version controlled with Git and repositories that don't have\nversion control at all. Any other version control system will be ignored."
  }, {
    "heading": "版本控制-version-control",
    "content": "请注意，我们使用 Git 对文件进行哈希处理，因此没有 Git 的仓库的性能和行为可能会有所不同。"
  }, {
    "heading": "版本控制-version-control",
    "content": "¥Note that we use Git to hash files, so repositories without git may perform and behave differently."
  }, {
    "heading": "lts-策略-lts-policy",
    "content": "¥LTS policy"
  }, {
    "heading": "lts-策略-lts-policy",
    "content": "Turborepo 的主要版本将在下一个主要版本发布之日起两年内提供支持。"
  }, {
    "heading": "lts-策略-lts-policy",
    "content": "¥Major versions of Turborepo will be supported for two years from the release date of the next major version."
  }, {
    "heading": "lts-策略-lts-policy",
    "content": "旧版本中关键安全修复所需的更改将被反向移植。这种情况很少见，即使它们是重大更改，也会以 semver 次要版本的形式发布。"
  }, {
    "heading": "lts-策略-lts-policy",
    "content": "¥Changes required for critical security fixes in older versions will be backported. Such situations will be rare and will land as semver-minor releases, even if they are breaking changes."
  }, {
    "heading": "lts-策略-lts-policy",
    "content": "我们强烈建议你尽可能使用 Turborepo 的最新版本。"
  }, {
    "heading": "lts-策略-lts-policy",
    "content": "¥We highly encourage you to use the most current version of Turborepo whenever possible."
  }, {
    "heading": "lts-策略-lts-policy",
    "content": "主版本号"
  }, {
    "heading": "lts-策略-lts-policy",
    "content": "发布日期"
  }, {
    "heading": "lts-策略-lts-policy",
    "content": "生命周期终止日期"
  }, {
    "heading": "lts-策略-lts-policy",
    "content": "2.x"
  }, {
    "heading": "lts-策略-lts-policy",
    "content": "六月4, 2024"
  }, {
    "heading": "lts-策略-lts-policy",
    "content": "*"
  }, {
    "heading": "lts-策略-lts-policy",
    "content": "1.x"
  }, {
    "heading": "lts-策略-lts-policy",
    "content": "Dec.9, 2021"
  }, {
    "heading": "lts-策略-lts-policy",
    "content": "六月4, 2026"
  }, {
    "heading": "发布阶段-release-phases",
    "content": "¥Release phases"
  }, {
    "heading": "发布阶段-release-phases",
    "content": "Turborepo 的稳定版本遵循语义版本控制 (semver)，并在发布前经过全面测试。"
  }, {
    "heading": "发布阶段-release-phases",
    "content": "¥Stable builds of Turborepo follow semantic versioning (semver) and are thoroughly tested before being released."
  }, {
    "heading": "发布阶段-release-phases",
    "content": "Turborepo 还提供可能在早期开发阶段发布的特定 API。这是为了让早期采用者能够提供宝贵的反馈，并帮助核心团队在 API 稳定发布之前建立对 API 的信心。在稳定之前可用的 API 将在文档和 turbo 中尽可能标记为稳定。"
  }, {
    "heading": "发布阶段-release-phases",
    "content": "¥Turborepo also offers specific APIs that may be released in an earlier phase of development. This is to allow early adopters to give valuable feedback and help the core team gain confidence in APIs ahead of their stable release. APIs that are available pre-stable will be marked as such in the documentation and within turbo itself whenever possible."
  }, {
    "heading": "发布阶段-release-phases",
    "content": "并非所有 API 都会在每个阶段发布。我们会根据对功能的信心，综合考虑功能的复杂性、可能的用例以及 API 早期用户的反馈等因素，运用最佳判断来确定 API 的阶段。"
  }, {
    "heading": "发布阶段-release-phases",
    "content": "¥Not every API will be released in every phase. We use our best judgment to determine the phase for an API based on our confidence for the feature, weighing factors like the feature's complexity, possible use cases, and feedback from early users of the API."
  }, {
    "heading": "发布阶段-release-phases",
    "content": "Turborepo 核心团队谨感谢所有提前使用功能的用户，并感谢你提供的任何反馈。"
  }, {
    "heading": "发布阶段-release-phases",
    "content": "¥The Turborepo core team would like to thank any users who do use features early and express our appreciation for any feedback you provide."
  }, {
    "heading": "稳定版-stable",
    "content": "¥Stable"
  }, {
    "heading": "稳定版-stable",
    "content": "当 API 达到稳定状态时，即被认为可以在生产环境中使用。标记为稳定的 API 仅在主要版本中以向后兼容的方式进行更改。"
  }, {
    "heading": "稳定版-stable",
    "content": "¥When an API reaches stability, it is considered ready for use in production. APIs marked as stable will only change in a backward-compatible way in a major release."
  }, {
    "heading": "稳定版-stable",
    "content": "如果稳定的 API 在即将发布的主要版本中发生重大更改，我们将提供警告和文档，以帮助迁移和后续步骤。"
  }, {
    "heading": "稳定版-stable",
    "content": "¥If a stable API is going to have breaking changes in an upcoming major release, warnings and documentation will be provided to help with migrations and next steps."
  }, {
    "heading": "稳定版-stable",
    "content": "如果某个稳定的 API 将在即将发布的主要版本中被移除，它将被标记为 已弃用，以便提前通知未来移除事宜。"
  }, {
    "heading": "稳定版-stable",
    "content": "¥If a stable API is going to be removed in an upcoming major release, it will be marked as Deprecated to provide early notice of future removal."
  }, {
    "heading": "beta-版-beta",
    "content": "¥Beta"
  }, {
    "heading": "beta-版-beta",
    "content": "Beta 版 API 在发布稳定版本之前，需要对可靠性有更高的信心。在 Beta 阶段，我们对该功能的整体设计充满信心，并期望能够通过相对较少的更改将该功能提升到稳定版本。在极少数情况下，API 可能需要进行重大更改，并且不会被 semver 覆盖。"
  }, {
    "heading": "beta-版-beta",
    "content": "¥Beta APIs require more confidence around reliability before a stable release. In the Beta phase, we are confident about the overall design of the feature and expect to be able to promote the feature to stable with relatively few changes. In rare cases, an API may require a breaking change and will not be covered by semver."
  }, {
    "heading": "beta-版-beta",
    "content": "我们鼓励早期采用者使用 Beta 版 API，以帮助我们确定该功能的设计和稳定性。根据你的风险承受能力，你可以根据需要在生产环境中使用该功能。"
  }, {
    "heading": "beta-版-beta",
    "content": "¥We encourage early adopters to use Beta APIs to help us gain certainty around the feature's design and stability. Depending on your risk tolerance, you can use the feature in production as you see fit."
  }, {
    "heading": "beta-版-beta",
    "content": "当前处于 Beta 阶段的 API："
  }, {
    "heading": "beta-版-beta",
    "content": "¥APIs currently in the Beta phase:"
  }, {
    "heading": "beta-版-beta",
    "content": "无"
  }, {
    "heading": "beta-版-beta",
    "content": "¥None"
  }, {
    "heading": "实验性-experimental",
    "content": "¥Experimental"
  }, {
    "heading": "实验性-experimental",
    "content": "实验性 API 缺乏实现稳定性所需的基本功能。该功能的设计被认为处于积极开发阶段，并且可能随时更改。"
  }, {
    "heading": "实验性-experimental",
    "content": "¥Experimental APIs lack essential capabilities required to be ready for stability. The design of the feature is considered to be under active development and can change at any time."
  }, {
    "heading": "实验性-experimental",
    "content": "我们鼓励你帮助我们在辅助项目、概念验证和其他稳定性并非至关重要的环境中测试实验性 API。这使你有机会在功能开发过程中向核心团队提供早期反馈，从而协助 API 的开发。我们不建议在可靠性至关重要的情况下使用实验性 API。"
  }, {
    "heading": "实验性-experimental",
    "content": "¥We encourage you to help us test experimental APIs in side projects, proof-of-concepts, and other environments where stability is non-essential. This gives you the opportunity to aid in the API's development by providing early feedback to the core team as the feature develops. We do not recommend using experimental APIs where reliability is essential."
  }, {
    "heading": "实验性-experimental",
    "content": "当前处于实验阶段的 API："
  }, {
    "heading": "实验性-experimental",
    "content": "¥APIs currently in the Experimental phase:"
  }, {
    "heading": "实验性-experimental",
    "content": "turbo query"
  }, {
    "heading": "实验性-experimental",
    "content": "turbo boundaries 和 标签"
  }, {
    "heading": "实验性-experimental",
    "content": "¥turbo boundaries and Tags"
  }, {
    "heading": "实验性-experimental",
    "content": "turbo watch 的 --experimental-write-cache"
  }, {
    "heading": "实验性-experimental",
    "content": "¥--experimental-write-cache for turbo watch"
  }, {
    "heading": "实验性-experimental",
    "content": "turbo ls --affected 的 --output=json 标志"
  }, {
    "heading": "实验性-experimental",
    "content": "¥--output=json for turbo ls --affected flag"
  }, {
    "heading": "已弃用-deprecated",
    "content": "¥Deprecated"
  }, {
    "heading": "已弃用-deprecated",
    "content": "已弃用的 API 正在被移除。我们打算删除的任何功能都将包含面向现有用户的文档，其中包含后续步骤以及有关何时删除该功能的信息。"
  }, {
    "heading": "已弃用-deprecated",
    "content": "¥Deprecated APIs are in the process of being removed. Any feature we intend to remove will include documentation for existing users with next steps and information on when to expect the feature to be removed."
  }, {
    "heading": "已弃用-deprecated",
    "content": "当前已弃用的 API："
  }, {
    "heading": "已弃用-deprecated",
    "content": "¥APIs that are currently deprecated:"
  }, {
    "heading": "已弃用-deprecated",
    "content": "TURBO_REMOTE_ONLY 和 --remote-only：使用 TURBO_CACHE 或 --cache"
  }, {
    "heading": "已弃用-deprecated",
    "content": "¥TURBO_REMOTE_ONLY and --remote-only: Use TURBO_CACHE or --cache"
  }],
  "headings": [{
    "id": "软件包管理器-package-managers",
    "content": "软件包管理器 /*package-managers*/"
  }, {
    "id": "平台-platforms",
    "content": "平台 /*platforms*/"
  }, {
    "id": "nodejs-nodejs",
    "content": "Node.js /*nodejs*/"
  }, {
    "id": "版本控制-version-control",
    "content": "版本控制 /*version-control*/"
  }, {
    "id": "lts-策略-lts-policy",
    "content": "LTS 策略 /*lts-policy*/"
  }, {
    "id": "发布阶段-release-phases",
    "content": "发布阶段 /*release-phases*/"
  }, {
    "id": "稳定版-stable",
    "content": "稳定版 /*stable*/"
  }, {
    "id": "beta-版-beta",
    "content": "Beta 版 /*beta*/"
  }, {
    "id": "实验性-experimental",
    "content": "实验性 /*experimental*/"
  }, {
    "id": "已弃用-deprecated",
    "content": "已弃用 /*deprecated*/"
  }]
};
import {Callout} from '#components/callout';
export const toc = [{
  depth: 2,
  url: "#软件包管理器-package-managers",
  title: _jsx(_Fragment, {
    children: "软件包管理器 "
  })
}, {
  depth: 2,
  url: "#平台-platforms",
  title: _jsx(_Fragment, {
    children: "平台 "
  })
}, {
  depth: 2,
  url: "#nodejs-nodejs",
  title: _jsx(_Fragment, {
    children: "Node.js "
  })
}, {
  depth: 2,
  url: "#版本控制-version-control",
  title: _jsx(_Fragment, {
    children: "版本控制 "
  })
}, {
  depth: 2,
  url: "#lts-策略-lts-policy",
  title: _jsx(_Fragment, {
    children: "LTS 策略 "
  })
}, {
  depth: 2,
  url: "#发布阶段-release-phases",
  title: _jsx(_Fragment, {
    children: "发布阶段 "
  })
}, {
  depth: 3,
  url: "#稳定版-stable",
  title: _jsx(_Fragment, {
    children: "稳定版 "
  })
}, {
  depth: 3,
  url: "#beta-版-beta",
  title: _jsx(_Fragment, {
    children: "Beta 版 "
  })
}, {
  depth: 3,
  url: "#实验性-experimental",
  title: _jsx(_Fragment, {
    children: "实验性 "
  })
}, {
  depth: 3,
  url: "#已弃用-deprecated",
  title: _jsx(_Fragment, {
    children: "已弃用 "
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    li: "li",
    p: "p",
    strong: "strong",
    table: "table",
    tbody: "tbody",
    td: "td",
    th: "th",
    thead: "thead",
    tr: "tr",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      id: "软件包管理器-package-managers",
      children: "软件包管理器 "
    }), "\n", _jsx(_components.p, {
      children: "¥Package managers"
    }), "\n", _jsxs(_components.p, {
      children: ["核心 ", _jsx(_components.code, {
        children: "turbo"
      }), " 功能依赖于 JavaScript 生态系统中的包管理器及其对工作区和锁文件格式的实现。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Core ", _jsx(_components.code, {
        children: "turbo"
      }), " functionality depends on the package managers in the JavaScript ecosystem and their implementations of Workspaces and\nlockfile formats."]
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "包管理器"
          }), _jsx(_components.th, {
            children: "支持"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "pnpm 8+"
          }), _jsx(_components.td, {
            children: "稳定版"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "npm 8+"
          }), _jsx(_components.td, {
            children: "稳定版"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "yarn 1+"
          }), _jsx(_components.td, {
            children: "稳定版（包含 Yarn Plug'n'Play）"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "bun 1.2+"
          }), _jsx(_components.td, {
            children: "稳定版"
          })]
        })]
      })]
    }), "\n", _jsxs(Callout, {
      type: "info",
      children: [_jsx(_components.p, {
        children: "软件包管理器有自己的发布计划、错误和功能。虽然我们打算跟上新的主要版本，但我们可能无法立即发布支持。"
      }), _jsx(_components.p, {
        children: "¥Package managers have their own release schedules, bugs, and features. While\nwe intend to keep up with new major versions, we likely will not be able to\nrelease support immediately."
      })]
    }), "\n", _jsx(_components.h2, {
      id: "平台-platforms",
      children: "平台 "
    }), "\n", _jsx(_components.p, {
      children: "¥Platforms"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo"
      }), " 通常支持基于 Debian 的 Linux 发行版、macOS 和 Windows 的 x86_64 和 ARM 64 架构。具体来说，我们通过 npm 构建并交付以下二进制文件："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.code, {
        children: "turbo"
      }), " is generally supported on Debian-based Linux distributions, macOS, and\nWindows on both x86_64 and ARM 64 architectures. Specifically, we build and ship\nthe following binaries via npm:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.code, {
            children: "turbo-darwin-64"
          }), "(搭载 Intel 的 macOS 芯片)"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.code, {
            children: "turbo-darwin-64"
          }), " (macOS with Intel chips)"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.code, {
            children: "turbo-darwin-arm64"
          }), "(搭载 Apple Silicon 的 macOS)"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.code, {
            children: "turbo-darwin-arm64"
          }), " (macOS with Apple Silicon)"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.code, {
            children: "turbo-linux-64"
          })
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.code, {
            children: "turbo-linux-arm64"
          })
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.code, {
            children: "turbo-windows-64"
          }), "*"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.code, {
            children: "turbo-windows-arm64"
          }), "*"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs("small", {
      children: [_jsxs(_components.p, {
        children: ["*: 需要 ", _jsx(_components.a, {
          href: "https://learn.microsoft.com/en-us/cpp/windows/latest-supported-vc-redist",
          children: "Windows C 运行时库"
        })]
      }), _jsxs(_components.p, {
        children: ["¥*: Requires ", _jsx(_components.a, {
          href: "https://learn.microsoft.com/en-us/cpp/windows/latest-supported-vc-redist",
          children: "Windows C Runtime\nLibraries"
        })]
      })]
    }), "\n", _jsx(_components.h2, {
      id: "nodejs-nodejs",
      children: "Node.js "
    }), "\n", _jsxs(_components.p, {
      children: ["核心 ", _jsx(_components.code, {
        children: "turbo"
      }), " 功能不依赖于系统上活动的 Node.js 版本，但 ", _jsx(_components.a, {
        href: "/docs/reference#packages",
        children: "Turborepo 生态系统中的一些包"
      }), "（例如 ", _jsx(_components.a, {
        href: "/docs/reference/create-turbo",
        children: _jsx(_components.code, {
          children: "create-turbo"
        })
      }), "、", _jsx(_components.a, {
        href: "/docs/reference/turbo-ignore",
        children: _jsx(_components.code, {
          children: "turbo-ignore"
        })
      }), " 和 ", _jsx(_components.a, {
        href: "/docs/reference/eslint-config-turbo",
        children: _jsx(_components.code, {
          children: "eslint-config-turbo"
        })
      }), "）依赖于此。对于这些功能，我们打算支持 ", _jsx(_components.a, {
        href: "https://nodejs.cn/about/previous-releases",
        children: "Node.js 的活跃和维护 LTS 版本"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Core ", _jsx(_components.code, {
        children: "turbo"
      }), " functionality does not depend on the\nactive Node.js version on your system, but ", _jsx(_components.a, {
        href: "/docs/reference#packages",
        children: "some packages in the Turborepo ecosystem"
      }), "\nsuch as ", _jsx(_components.a, {
        href: "/docs/reference/create-turbo",
        children: _jsx(_components.code, {
          children: "create-turbo"
        })
      }), ", ", _jsx(_components.a, {
        href: "/docs/reference/turbo-ignore",
        children: _jsx(_components.code, {
          children: "turbo-ignore"
        })
      }), ", and ", _jsx(_components.a, {
        href: "/docs/reference/eslint-config-turbo",
        children: _jsx(_components.code, {
          children: "eslint-config-turbo"
        })
      }), " do. For these features,\nwe intend to support the ", _jsx(_components.a, {
        href: "https://nodejs.cn/about/previous-releases",
        children: "Active and Maintenance LTS versions of Node.js"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo 的 ", _jsx(_components.a, {
        href: "/docs/getting-started/examples",
        children: "examples"
      }), " 预计也适用于这些 Node.js 版本。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Turborepo's ", _jsx(_components.a, {
        href: "/docs/getting-started/examples",
        children: "examples"
      }), " are also expected to work with these Node.js versions."]
    }), "\n", _jsx(_components.h2, {
      id: "版本控制-version-control",
      children: "版本控制 "
    }), "\n", _jsx(_components.p, {
      children: "¥Version control"
    }), "\n", _jsx(_components.p, {
      children: "我们支持使用 Git 进行版本控制的仓库，也支持完全没有版本控制的仓库。任何其他版本控制系统都将被忽略。"
    }), "\n", _jsx(_components.p, {
      children: "¥We support repositories that are version controlled with Git and repositories that don't have\nversion control at all. Any other version control system will be ignored."
    }), "\n", _jsx(_components.p, {
      children: "请注意，我们使用 Git 对文件进行哈希处理，因此没有 Git 的仓库的性能和行为可能会有所不同。"
    }), "\n", _jsx(_components.p, {
      children: "¥Note that we use Git to hash files, so repositories without git may perform and behave differently."
    }), "\n", _jsx(_components.h2, {
      id: "lts-策略-lts-policy",
      children: "LTS 策略 "
    }), "\n", _jsx(_components.p, {
      children: "¥LTS policy"
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 的主要版本将在下一个主要版本发布之日起两年内提供支持。"
    }), "\n", _jsx(_components.p, {
      children: "¥Major versions of Turborepo will be supported for two years from the release date of the next major version."
    }), "\n", _jsx(_components.p, {
      children: "旧版本中关键安全修复所需的更改将被反向移植。这种情况很少见，即使它们是重大更改，也会以 semver 次要版本的形式发布。"
    }), "\n", _jsx(_components.p, {
      children: "¥Changes required for critical security fixes in older versions will be backported. Such situations will be rare and will land as semver-minor releases, even if they are breaking changes."
    }), "\n", _jsx(_components.p, {
      children: "我们强烈建议你尽可能使用 Turborepo 的最新版本。"
    }), "\n", _jsx(_components.p, {
      children: "¥We highly encourage you to use the most current version of Turborepo whenever possible."
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "主版本号"
          }), _jsx(_components.th, {
            children: "发布日期"
          }), _jsx(_components.th, {
            children: "生命周期终止日期"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "2.x"
          }), _jsx(_components.td, {
            children: "六月4, 2024"
          }), _jsx(_components.td, {
            children: "*"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "1.x"
          }), _jsx(_components.td, {
            children: "Dec.9, 2021"
          }), _jsx(_components.td, {
            children: "六月4, 2026"
          })]
        })]
      })]
    }), "\n", _jsx(_components.h2, {
      id: "发布阶段-release-phases",
      children: "发布阶段 "
    }), "\n", _jsx(_components.p, {
      children: "¥Release phases"
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 的稳定版本遵循语义版本控制 (semver)，并在发布前经过全面测试。"
    }), "\n", _jsx(_components.p, {
      children: "¥Stable builds of Turborepo follow semantic versioning (semver) and are thoroughly tested before being released."
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo 还提供可能在早期开发阶段发布的特定 API。这是为了让早期采用者能够提供宝贵的反馈，并帮助核心团队在 API 稳定发布之前建立对 API 的信心。在稳定之前可用的 API 将在文档和 ", _jsx(_components.code, {
        children: "turbo"
      }), " 中尽可能标记为稳定。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Turborepo also offers specific APIs that may be released in an earlier phase of development. This is to allow early adopters to give valuable feedback and help the core team gain confidence in APIs ahead of their stable release. APIs that are available pre-stable will be marked as such in the documentation and within ", _jsx(_components.code, {
        children: "turbo"
      }), " itself whenever possible."]
    }), "\n", _jsx(_components.p, {
      children: "并非所有 API 都会在每个阶段发布。我们会根据对功能的信心，综合考虑功能的复杂性、可能的用例以及 API 早期用户的反馈等因素，运用最佳判断来确定 API 的阶段。"
    }), "\n", _jsx(_components.p, {
      children: "¥Not every API will be released in every phase. We use our best judgment to determine the phase for an API based on our confidence for the feature, weighing factors like the feature's complexity, possible use cases, and feedback from early users of the API."
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 核心团队谨感谢所有提前使用功能的用户，并感谢你提供的任何反馈。"
    }), "\n", _jsx(_components.p, {
      children: "¥The Turborepo core team would like to thank any users who do use features early and express our appreciation for any feedback you provide."
    }), "\n", _jsx(_components.h3, {
      id: "稳定版-stable",
      children: "稳定版 "
    }), "\n", _jsx(_components.p, {
      children: "¥Stable"
    }), "\n", _jsx(_components.p, {
      children: "当 API 达到稳定状态时，即被认为可以在生产环境中使用。标记为稳定的 API 仅在主要版本中以向后兼容的方式进行更改。"
    }), "\n", _jsx(_components.p, {
      children: "¥When an API reaches stability, it is considered ready for use in production. APIs marked as stable will only change in a backward-compatible way in a major release."
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "如果稳定的 API 在即将发布的主要版本中发生重大更改，我们将提供警告和文档，以帮助迁移和后续步骤。"
        }), "\n", _jsxs(_components.p, {
          children: ["¥If a stable API is going to ", _jsx(_components.strong, {
            children: "have breaking changes"
          }), " in an upcoming major release, warnings and documentation will be provided to help with migrations and next steps."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["如果某个稳定的 API 将在即将发布的主要版本中被移除，它将被标记为 ", _jsx(_components.a, {
            href: "#deprecated",
            children: "已弃用"
          }), "，以便提前通知未来移除事宜。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥If a stable API is going to be ", _jsx(_components.strong, {
            children: "removed"
          }), " in an upcoming major release, it will be marked as ", _jsx(_components.a, {
            href: "#deprecated",
            children: "Deprecated"
          }), " to provide early notice of future removal."]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "beta-版-beta",
      children: "Beta 版 "
    }), "\n", _jsx(_components.p, {
      children: "¥Beta"
    }), "\n", _jsx(_components.p, {
      children: "Beta 版 API 在发布稳定版本之前，需要对可靠性有更高的信心。在 Beta 阶段，我们对该功能的整体设计充满信心，并期望能够通过相对较少的更改将该功能提升到稳定版本。在极少数情况下，API 可能需要进行重大更改，并且不会被 semver 覆盖。"
    }), "\n", _jsx(_components.p, {
      children: "¥Beta APIs require more confidence around reliability before a stable release. In the Beta phase, we are confident about the overall design of the feature and expect to be able to promote the feature to stable with relatively few changes. In rare cases, an API may require a breaking change and will not be covered by semver."
    }), "\n", _jsx(_components.p, {
      children: "我们鼓励早期采用者使用 Beta 版 API，以帮助我们确定该功能的设计和稳定性。根据你的风险承受能力，你可以根据需要在生产环境中使用该功能。"
    }), "\n", _jsx(_components.p, {
      children: "¥We encourage early adopters to use Beta APIs to help us gain certainty around the feature's design and stability. Depending on your risk tolerance, you can use the feature in production as you see fit."
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "当前处于 Beta 阶段的 API："
      })
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.strong, {
        children: "APIs currently in the Beta phase:"
      })]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "无"
        }), "\n", _jsx(_components.p, {
          children: "¥None"
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "实验性-experimental",
      children: "实验性 "
    }), "\n", _jsx(_components.p, {
      children: "¥Experimental"
    }), "\n", _jsx(_components.p, {
      children: "实验性 API 缺乏实现稳定性所需的基本功能。该功能的设计被认为处于积极开发阶段，并且可能随时更改。"
    }), "\n", _jsx(_components.p, {
      children: "¥Experimental APIs lack essential capabilities required to be ready for stability. The design of the feature is considered to be under active development and can change at any time."
    }), "\n", _jsx(_components.p, {
      children: "我们鼓励你帮助我们在辅助项目、概念验证和其他稳定性并非至关重要的环境中测试实验性 API。这使你有机会在功能开发过程中向核心团队提供早期反馈，从而协助 API 的开发。我们不建议在可靠性至关重要的情况下使用实验性 API。"
    }), "\n", _jsx(_components.p, {
      children: "¥We encourage you to help us test experimental APIs in side projects, proof-of-concepts, and other environments where stability is non-essential. This gives you the opportunity to aid in the API's development by providing early feedback to the core team as the feature develops. We do not recommend using experimental APIs where reliability is essential."
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "当前处于实验阶段的 API："
      })
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.strong, {
        children: "APIs currently in the Experimental phase:"
      })]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.a, {
            href: "/docs/reference/query",
            children: _jsx(_components.code, {
              children: "turbo query"
            })
          })
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.a, {
            href: "/docs/reference/boundaries",
            children: _jsx(_components.code, {
              children: "turbo boundaries"
            })
          }), " 和 ", _jsx(_components.a, {
            href: "/docs/reference/boundaries#tags",
            children: "标签"
          })]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "/docs/reference/boundaries",
            children: _jsx(_components.code, {
              children: "turbo boundaries"
            })
          }), " and ", _jsx(_components.a, {
            href: "/docs/reference/boundaries#tags",
            children: "Tags"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsxs(_components.a, {
            href: "/docs/reference/watch#caching",
            children: [_jsx(_components.code, {
              children: "turbo watch"
            }), " 的 ", _jsx(_components.code, {
              children: "--experimental-write-cache"
            })]
          })
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsxs(_components.a, {
            href: "/docs/reference/watch#caching",
            children: [_jsx(_components.code, {
              children: "--experimental-write-cache"
            }), " for ", _jsx(_components.code, {
              children: "turbo watch"
            })]
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsxs(_components.a, {
            href: "/docs/reference/ls",
            children: [_jsx(_components.code, {
              children: "turbo ls --affected"
            }), " 的 ", _jsx(_components.code, {
              children: "--output=json"
            }), " 标志"]
          })
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsxs(_components.a, {
            href: "/docs/reference/ls",
            children: [_jsx(_components.code, {
              children: "--output=json"
            }), " for ", _jsx(_components.code, {
              children: "turbo ls --affected"
            }), " flag"]
          })]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "已弃用-deprecated",
      children: "已弃用 "
    }), "\n", _jsx(_components.p, {
      children: "¥Deprecated"
    }), "\n", _jsx(_components.p, {
      children: "已弃用的 API 正在被移除。我们打算删除的任何功能都将包含面向现有用户的文档，其中包含后续步骤以及有关何时删除该功能的信息。"
    }), "\n", _jsx(_components.p, {
      children: "¥Deprecated APIs are in the process of being removed. Any feature we intend to remove will include documentation for existing users with next steps and information on when to expect the feature to be removed."
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "当前已弃用的 API："
      })
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.strong, {
        children: "APIs that are currently deprecated:"
      })]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.code, {
            children: "TURBO_REMOTE_ONLY"
          }), " 和 ", _jsx(_components.code, {
            children: "--remote-only"
          }), "：使用 ", _jsx(_components.a, {
            href: "/docs/reference/system-environment-variables",
            children: _jsx(_components.code, {
              children: "TURBO_CACHE"
            })
          }), " 或 ", _jsx(_components.a, {
            href: "/docs/reference/run#--cache-options",
            children: "--cache"
          })]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.code, {
            children: "TURBO_REMOTE_ONLY"
          }), " and ", _jsx(_components.code, {
            children: "--remote-only"
          }), ": Use ", _jsx(_components.a, {
            href: "/docs/reference/system-environment-variables",
            children: _jsx(_components.code, {
              children: "TURBO_CACHE"
            })
          }), " or ", _jsx(_components.a, {
            href: "/docs/reference/run#--cache-options",
            children: "--cache"
          })]
        }), "\n"]
      }), "\n"]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
